export interface TelephoneNumberAddressIdentityParams {
  Address: string;
  CallerIdName: string;
  CallerIdNumber: string;
}

export interface ApiTelephoneNumberAddressIdentity {
  AddressIdentityId: string;
  CallerIdName: string;
  CallerIdNumber: string;
  Name: string;
  Type: string;
  Username: string;
  Domain: string;
}

export interface TelephoneNumberAddressIdentity {
  addressIdentityId: string;
  callerIdName: string;
  callerIdNumber: string;
  name: string;
  type: string;
  username: string;
  domain: string;
}

export function ApiTelephoneNumberAddressIdentityToTelephoneNumberAddressIdentity(
  apiTelephoneNumberIdentity: ApiTelephoneNumberAddressIdentity
): TelephoneNumberAddressIdentity {
  return {
    addressIdentityId: apiTelephoneNumberIdentity?.AddressIdentityId,
    callerIdName: apiTelephoneNumberIdentity?.CallerIdName,
    callerIdNumber: apiTelephoneNumberIdentity?.CallerIdNumber,
    name: apiTelephoneNumberIdentity?.Name,
    type: apiTelephoneNumberIdentity?.Type,
    username: apiTelephoneNumberIdentity?.Username,
    domain: apiTelephoneNumberIdentity?.Domain
  };
}
